function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { warn } from '@algolia/autocomplete-shared';
import { defaultTemplates } from './templates';
function defaultTransformResponse(response) {
  var _renderingContent, _renderingContent$red;
  return (_renderingContent = response.renderingContent) === null || _renderingContent === void 0 ? void 0 : (_renderingContent$red = _renderingContent.redirect) === null || _renderingContent$red === void 0 ? void 0 : _renderingContent$red.url;
}
function defaultTransformResponseToQuery(response) {
  return response.query;
}
function defaultOnRedirect(redirects, _ref) {
  var _item$urls;
  var event = _ref.event,
    navigator = _ref.navigator,
    state = _ref.state;
  var item = redirects[0];
  var itemUrl = item === null || item === void 0 ? void 0 : (_item$urls = item.urls) === null || _item$urls === void 0 ? void 0 : _item$urls[0];
  if (!itemUrl) {
    return;
  }
  if (event.metaKey || event.ctrlKey) {
    navigator.navigateNewTab({
      itemUrl: itemUrl,
      item: item,
      state: state
    });
  } else if (event.shiftKey) {
    navigator.navigateNewWindow({
      itemUrl: itemUrl,
      item: item,
      state: state
    });
  } else {
    navigator.navigate({
      itemUrl: itemUrl,
      item: item,
      state: state
    });
  }
}
function getOptions(options) {
  return _objectSpread({
    transformResponse: defaultTransformResponse,
    transformResponseToQuery: defaultTransformResponseToQuery,
    templates: defaultTemplates,
    onRedirect: defaultOnRedirect
  }, options);
}
function getRedirectData(_ref2) {
  var _redirectUrlPlugin$da;
  var state = _ref2.state;
  var redirectUrlPlugin = state.context.redirectUrlPlugin;
  return (_redirectUrlPlugin$da = redirectUrlPlugin === null || redirectUrlPlugin === void 0 ? void 0 : redirectUrlPlugin.data) !== null && _redirectUrlPlugin$da !== void 0 ? _redirectUrlPlugin$da : [];
}
export function createRedirectUrlPlugin() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _getOptions = getOptions(options),
    transformResponse = _getOptions.transformResponse,
    transformResponseToQuery = _getOptions.transformResponseToQuery,
    templates = _getOptions.templates,
    onRedirect = _getOptions.onRedirect;
  function createRedirects(_ref3) {
    var _state$context$redire, _state$context$redire2;
    var results = _ref3.results,
      source = _ref3.source,
      state = _ref3.state;
    var redirect = {
      sourceId: source.sourceId,
      urls: results.map(function (result) {
        return transformResponse(result);
      }).filter(function (url) {
        return url !== undefined;
      })
    };
    var redirects = (_state$context$redire = (_state$context$redire2 = state.context.redirectUrlPlugin) === null || _state$context$redire2 === void 0 ? void 0 : _state$context$redire2.data) !== null && _state$context$redire !== void 0 ? _state$context$redire : [];
    var existingRedirectIndex = redirects.findIndex(function (r) {
      return r.sourceId === source.sourceId;
    });
    if (existingRedirectIndex !== -1) {
      if (redirect.urls.length === 0) {
        redirects.splice(existingRedirectIndex, 1);
      } else {
        redirects[existingRedirectIndex] = redirect;
      }
    } else if (redirect.urls.length > 0) {
      redirects.push(redirect);
    }
    return redirects;
  }
  return {
    name: 'aa.redirectUrlPlugin',
    subscribe: function subscribe(_ref4) {
      var onResolve = _ref4.onResolve,
        onSelect = _ref4.onSelect,
        setContext = _ref4.setContext,
        setIsOpen = _ref4.setIsOpen;
      onResolve(function (_ref5) {
        var results = _ref5.results,
          source = _ref5.source,
          state = _ref5.state;
        // Ensure the resolved response matches the input query text before processing redirects.
        var matchesCurrentQuery = results.some(function (result) {
          return transformResponseToQuery(result) === state.query;
        });
        if (!matchesCurrentQuery) {
          return;
        }
        setContext(_objectSpread(_objectSpread({}, state.context), {}, {
          redirectUrlPlugin: {
            data: createRedirects({
              results: results,
              source: source,
              state: state
            })
          }
        }));
      });
      onSelect(function (_ref6) {
        var state = _ref6.state;
        var redirects = getRedirectData({
          state: state
        });
        if (redirects.length > 0) {
          setIsOpen(true);
        }
      });
    },
    reshape: function reshape(_ref7) {
      var _data, _state$context$redire3;
      var state = _ref7.state,
        sourcesBySourceId = _ref7.sourcesBySourceId;
      var redirects = (_data = (_state$context$redire3 = state.context.redirectUrlPlugin) === null || _state$context$redire3 === void 0 ? void 0 : _state$context$redire3.data) !== null && _data !== void 0 ? _data : [];
      redirects.forEach(function (redirect) {
        var source = sourcesBySourceId[redirect.sourceId];
        if (source === undefined) {
          return;
        }
        sourcesBySourceId[redirect.sourceId] = _objectSpread(_objectSpread({}, source), {}, {
          getItems: function getItems() {
            return source.getItems().filter(function (item) {
              if (source.getItemInputValue.__default) {
                process.env.NODE_ENV !== 'production' ? warn(false, "The source ".concat(JSON.stringify(source.sourceId), " does not have a `getItemInputValue` function. It's required to be able to filter out the redirect item.") + '\nSee https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getiteminputvalue') : void 0;
                return true;
              }
              var itemInputValue = source.getItemInputValue({
                item: item,
                state: state
              });
              if (itemInputValue === undefined) {
                process.env.NODE_ENV !== 'production' ? warn(false, "The source ".concat(JSON.stringify(source.sourceId), " does not return a string from the `getItemInputValue` function. It's required to be able to filter out the redirect item.") + '\nSee https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getiteminputvalue') : void 0;
                return true;
              }
              return itemInputValue.toLowerCase() !== state.query.toLowerCase();
            });
          }
        });
      });
      var redirectSource = {
        sourceId: 'redirectUrlPlugin',
        templates: templates,
        getItemUrl: function getItemUrl(_ref8) {
          var item = _ref8.item;
          return item.urls[0];
        },
        onSelect: function onSelect(_ref9) {
          var event = _ref9.event,
            item = _ref9.item,
            state = _ref9.state,
            navigator = _ref9.navigator;
          onRedirect([item], {
            event: event,
            navigator: navigator,
            state: state
          });
        },
        getItemInputValue: function getItemInputValue() {
          return state.query;
        },
        onActive: function onActive() {},
        getItems: function getItems() {
          return getRedirectData({
            state: state
          });
        }
      };
      process.env.NODE_ENV !== 'production' ? warn(sourcesBySourceId.redirect === undefined, 'A source with `sourceId: "redirect"` already exists. This source will be overridden.') : void 0;
      return {
        sourcesBySourceId: _objectSpread({
          // Our source has templates, but reshape only accepts sources without templates (autocomplete-core)
          redirect: redirectSource
        }, sourcesBySourceId),
        state: state
      };
    },
    onSubmit: function onSubmit(_ref0) {
      var event = _ref0.event,
        navigator = _ref0.navigator,
        state = _ref0.state;
      onRedirect(getRedirectData({
        state: state
      }), {
        event: event,
        navigator: navigator,
        state: state
      });
    },
    __autocomplete_pluginOptions: options
  };
}